// src/components/gallery/PhotoGrid.jsx
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../Loader";
import PhotoCard from "./PhotoCard";
import { useEffect } from "react";
import { UploadCloudIcon } from "lucide-react";

const PhotoGrid = ({
  displayedPhotos,
  allPhotos,
  loadMorePhotos,
  onPhotoClick,
  setLoading,
  hasMore,
  onUploadClick,
}) => {
  useEffect(() => {
    setLoading(false);
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && displayedPhotos.length < allPhotos.length) {
          loadMorePhotos();
        }
      },
      { threshold: 1.0 }
    );
    const sentinel = document.getElementById("sentinel");
    if (sentinel) {
      observer.observe(sentinel);
    }
    return () => {
      if (sentinel) {
        observer.unobserve(sentinel);
      }
    };
  }, [allPhotos, displayedPhotos]);

  if (displayedPhotos.length === 0) {
    return (
      <>
        <div className="flex flex-col items-center justify-center py-10 gap-4">
          <p className="text-center text-gray-500 text-lg">
            This album is empty… waiting for its first memory.
          </p>

          <button
            onClick={onUploadClick}
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
            <UploadCloudIcon className="h-4 w-4 mr-2" />
            Upload
          </button>
        </div>
      </>
    );
  }

  return (
    <InfiniteScroll
      dataLength={displayedPhotos.length}
      next={loadMorePhotos}
      hasMore={hasMore}
      loader={
        displayedPhotos.length > 0 && hasMore ? (
          <p className="text-center py-4">
            <Loader size="small" />
          </p>
        ) : null
      }
      endMessage={
        <p className="text-center py-4 text-gray-500">No more photos</p>
      }>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {displayedPhotos.map((photo) => (
          <PhotoCard key={photo.id} photo={photo} onClick={onPhotoClick} />
        ))}
      </div>
    </InfiniteScroll>
  );
};

export default PhotoGrid;
